<div class="form-group" [ngClass]="{ row: !!horizontal }">
  <label
    [for]="inputId"
    *ngIf="!suppressLabel"
    class="col-form-label"
    [ngClass]="{ 'col-12 col-sm-4': !!horizontal, 'font-weight-bold': !!labelBold, labelClass: !!labelClass }"
  >
    {{ translateTag | translate: translateParams }}
    <i *ngIf="!!tooltip" class="fal fa-question-circle" ngbTooltip="{{ tooltip | translate }}"></i>
  </label>
  <div [ngClass]="{ col: !!horizontal }" [ngStyle]="editorBgStyle">
    <angular-editor
      #editor
      [placeholder]="placeholder | translate"
      [(ngModel)]="value"
      [config]="angularEditorConfig"
      [name]="inputId"
      [id]="inputId"
      [ngClass]="{ extraInputClass: !!extraInputClass }"
      [disabled]="disabled"
      [required]="required"
      style="height: auto"
      (blur)="onTouched()"
    >
    <ng-template #customButtons let-executeCommandFn="executeCommandFn">
      <div class="angular-editor-toolbar-set">
        <select class="ae-font-size" (change)="onFontSizeChange($event.target.value, executeCommandFn); $event.target.value = ''">
        <option value=""><span translate>FONT_SIZE</span></option>
        <option *ngFor="let s of fontSizes" [value]="s">{{ s }} px</option>
      </select>
      </div>
      
    </ng-template>
  </angular-editor>
  </div>
</div>

<ng-template #loading> LOADING <i class="fas fa-spinner fa-spin ml-2"></i> </ng-template>
